
import Vue from 'vue'
import LoginService from "@/services/LoginService";
import EventBus from '@/plugins/event-bus'
import EstadoCuentaPublic from '@/components/Common/EstadoCuentaPublic.vue';

export default Vue.extend({
  name: 'estadoCuentaView',
  components: {
    EstadoCuentaPublic
  },
  data: () => ({
    form: {
      clave_catastral: "",
    },
    letsee: false,
    establecimientoSelected: null as any,
    dialogEstadoCuenta: false,
    dialogPredial: false,
  }),
  computed: {
  },
  mounted() {

  },
  methods: {
    async generar() {
      this.dialogPredial = true;
    },
    closeEstadoCuenta() {
      this.dialogEstadoCuenta = false;
    },
    pagarPredialLinea() {
      console.log('paggar predial en linea');
      this.abrirVentanaFlotante();
    },
    generarPagoPredial() {
      this.dialogEstadoCuenta = true;
    },
    abrirVentanaFlotante() {
      const url = 'https://sistemas2.opb.gob.mx/pagosOnline/pagos_linea.php';
      const ancho = 800;
      const alto = 600;

      // Centrar la ventana flotante
      const izquierda = (window.screen.width / 2) - (ancho / 2);
      const arriba = (window.screen.height / 2) - (alto / 2);

      // Crear un formulario y enviarlo en una nueva ventana
      const formulario = document.createElement('form');
      formulario.method = 'post';
      formulario.action = url;
      formulario.target = 'ventanaFlotante';
      formulario.style.display = 'none'; // Ocultar el formulario

      // Crear los campos del formulario
      const campos = [
        { name: 'idServicio', value: '2' },
        { name: 'claveEstablecimiento', value: this.form.clave_catastral },
        { name: 'estatusEstadoCuenta', value: 'A' },
        { name: 'folioEstadoCuenta', value: '1' }
      ];

      campos.forEach(campo => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = campo.name;
        input.value = campo.value;
        formulario.appendChild(input);
      });

      // Añadir el formulario al documento y enviarlo
      document.body.appendChild(formulario);

      // Abrir la ventana emergente
      window.open('', 'ventanaFlotante', `width = ${ ancho }, height = ${ alto }, top = ${ arriba }, left = ${ izquierda }, resizable = yes, scrollbars = yes`);

      // Enviar el formulario
      formulario.submit();

      // Limpiar el formulario
      document.body.removeChild(formulario);

    },
  },
  filters: {

  }
})
